export default "__VITE_ASSET__d79q8no$__"